module.exports = __webpack_public_path__ + "media/images/cropper-green 2-afb064fdb67a440e1a273a7acdbe070d.png";